'use client';

import type { ReactNode } from 'react';
import { TerminalRenderer } from '../../ToolCallsRenderers/renderers/TerminalRenderer';
import type { OutputRenderContext } from '../../tool-config-types';

export const renderTerminalResult = (ctx: OutputRenderContext): ReactNode => {
  const { content, maxHeight } = ctx;
  return <TerminalRenderer data={content} maxHeight={maxHeight} />;
};
